module.exports = {
  TV_R3: function(reach1, grps) {
    var z = Math.log(grps)*(1.25518161890535)-(7.70477803410043);
    var reach3 = 0.95/(1 + Math.exp(-z)) * 100;
    if(reach3 > reach1){
      reach3 = reach1;
    }
    return reach3;
  },
  PC_R3: function(reach1, grps) {
    var z = Math.log(grps)*(0.932697884827294)-(7.25543856455021);
    var reach3 = 0.95/(1 + Math.exp(-z)) * 100;
    if(reach3 > reach1){
      reach3 = reach1;
    }
    return reach3;
  },
  Mobile_R3: function(reach1, grps) {
    var z = Math.log(grps)*(1.1236785612063476)-(7.423793239314694);
    var reach3 = 0.95/(1 + Math.exp(-z)) * 100;
    if(reach3 > reach1){
      reach3 = reach1;
    }
    return reach3;
  },
  Digital_R3: function(reach1, grps) {
    var z = Math.log(grps)*(1.1434073956454247)-(7.506178226293352);
    var reach3 = 0.95/(1 + Math.exp(-z)) * 100;
    if(reach3 > reach1){
      reach3 = reach1;
    }
    return reach3;
  },
  PC_MO_R3: function(pcReach3, moReach3){
    var reach3 = (
                   pcReach3/100*(1.0292567139829)
                 + moReach3/100*(1.00722466866764)
                 + ( (pcReach3/100) * (moReach3/100) * (-1.07084422224848) )
               ) * 100;
    return reach3;
  },
  TV_PC_MO_R3: function(tvReach3, pcmoReach3){
    var reach3 = (
                   tvReach3/100*(1.00988782853382)
                 + pcmoReach3/100*(1.00236975734575)
                 + ( (tvReach3/100) * (pcmoReach3/100) * (-1.02020337227138) )
                 + (0.000294005114961705)
              ) * 100;
    return reach3;
  },
}



// WEBPACK FOOTER //
// ./src/views/common/Reach3Logic.js